<template>
  <v-row no-gutters justify="center">
    <v-col cols="auto" class="text-center">
      <grayscale-mode-button
        v-if="!oct"
        image="red-icon.png"
        title="Red"
        :size="size"
        :fab="true"
        :grayscaleMode="grayscaleModes.Red"
        :selectedGrayscaleMode="grayscaleMode"
        @toggleGrayscaleMode="$emit('input', grayscaleModes.Red)"/>
      <grayscale-mode-button
        v-if="!oct"
        image="green-icon.png"
        title="Green"
        :size="size"
        :fab="true"
        :grayscaleMode="grayscaleModes.Green"
        :selectedGrayscaleMode="grayscaleMode"
        @toggleGrayscaleMode="$emit('input', grayscaleModes.Green)"/>
      <grayscale-mode-button
        v-if="!optos && !oct"
        image="blue-icon.png"
        :size="size"
        :fab="true"
        :grayscaleMode="grayscaleModes.Blue"
        :selectedGrayscaleMode="grayscaleMode"
        @toggleGrayscaleMode="$emit('input', grayscaleModes.Blue)"/>
      <grayscale-mode-button
        v-if="!oct"
        image="bw-circle-icon.png"
        title="Monochrome"
        :size="size"
        :fab="true"
        :grayscaleMode="grayscaleModes.REC709"
        :selectedGrayscaleMode="grayscaleMode"
        @toggleGrayscaleMode="$emit('input', grayscaleModes.REC709)"/>
      <circle-image-button
        :active="isDragLock"
        :image="dragIcon"
        :size="size"
        title="Drag"
        btnClass="primary"
        @click="$emit('dragButtonClick')"/>
      <circle-image-button
        :image="mouseWheelZoomImage"
        :title="mouseWheelZoomText"
        :size="size"
        @click="$emit('toggleMouseWheelZoom')"
        btnClass="primary"/>
    </v-col>
  </v-row>
</template>

<script>
import { GRAYSCALE_MODES, ANNOTATION_MODES } from "../../../config/config";
import grayscaleModeButton from "../../imageBrowser/controls/GrayscaleModeButton";
import circleImageButton from "../../controls/CircleImageButton";

export default {
  name: "annotationGrayscaleButtonCollection",
  components: { grayscaleModeButton, circleImageButton },
  props: {
    context: Object,
    size: { type: String, default: "small" },
    oct: Boolean,
    optos: Boolean,
    isDragLock: Boolean,
    grayscaleMode: String
  },
  data() {
    return {
      grayscaleModes: GRAYSCALE_MODES,
      annotationModes: ANNOTATION_MODES
    };
  },
  computed: {
    dragIcon() {
      return this.isDragLock
        ? this.activeAnnotationIcons.drag
        : this.coloredAssetUrls.drag;
    },
    mouseWheelZoomImage() {
      if (!this.context.mouseWheelZoom)
        return this.coloredAssetUrls.mousezoom;
      return this.coloredAssetUrls.advance;
    },
    mouseWheelZoomText() {
      if (!this.context.mouseWheelZoom)
        return "Scroll to Zoom";
      return "Scroll to Advance";
    }
  },
  methods: {
    buttonClass(color) {
      let btnClass = "rounded-button annotation-color-button "  + this.colorClass;
      if (color === this.value) btnClass += " selected-color";
      return btnClass;
    }
  }
};
</script>
